(() => {
  const ROOT = '[data-net-reference-header]';
  const OPEN_DELAY = 0;
  const CLOSE_DELAY = 200;

  function initMenu(header) {
    const nav = header.querySelector('[data-net-nav]');
    const mega = header.querySelector('[data-net-mega]');
    const megaToggle = header.querySelector('[data-net-mega-toggle]');
    if (!nav || !mega || !megaToggle || nav.dataset.netMenuInit === 'true') return;
    nav.dataset.netMenuInit = 'true';

    let closeTimer = 0;
    let openTimer = 0;
    let positionFrame = null;
    const controller = new AbortController();
    const { signal } = controller;
    const items = [...nav.querySelectorAll('[data-net-nav-item]')];

    function clearTimers() {
      clearTimeout(closeTimer);
      clearTimeout(openTimer);
    }

    function hideMega() {
      mega.hidden = true;
      megaToggle.setAttribute('aria-expanded', 'false');
    }

    function closeItems(except = null) {
      items.forEach(item => {
        if (item === except) return;
        const button = item.querySelector('[data-net-nav-button]');
        const dropdown = item.querySelector('[data-net-nav-dropdown]');
        button?.setAttribute('aria-expanded', 'false');
        if (dropdown) dropdown.hidden = true;
      });
    }

    function positionDropdown(item) {
      const button = item.querySelector('[data-net-nav-button]');
      const dropdown = item.querySelector('[data-net-nav-dropdown]');
      if (!button || !dropdown) return;
      const rect = button.getBoundingClientRect();
      const top = `${Math.round(rect.bottom)}px`;
      const left = `${Math.max(0, Math.min(rect.left, window.innerWidth - dropdown.offsetWidth - 8))}px`;
      if (dropdown.style.top !== top) dropdown.style.top = top;
      if (dropdown.style.left !== left) dropdown.style.left = left;
    }

    function schedulePosition() {
      if (signal.aborted || positionFrame !== null) return;
      if (!items.some(item => {
        const dropdown = item.querySelector('[data-net-nav-dropdown]');
        return dropdown && !dropdown.hidden;
      })) return;
      positionFrame = requestAnimationFrame(() => {
        positionFrame = null;
        if (signal.aborted) return;
        items.forEach(item => {
          const dropdown = item.querySelector('[data-net-nav-dropdown]');
          if (dropdown && !dropdown.hidden) positionDropdown(item);
        });
      });
    }

    function openItem(item) {
      clearTimers();
      hideMega();
      closeItems(item);
      const button = item.querySelector('[data-net-nav-button]');
      const dropdown = item.querySelector('[data-net-nav-dropdown]');
      if (!button || !dropdown) return;
      dropdown.hidden = false;
      button.setAttribute('aria-expanded', 'true');
      schedulePosition();
    }

    function scheduleClose() {
      clearTimeout(closeTimer);
      closeTimer = window.setTimeout(() => {
        hideMega();
        closeItems();
      }, CLOSE_DELAY);
    }

    megaToggle.addEventListener('pointerenter', () => {
      clearTimers();
      closeItems();
      openTimer = window.setTimeout(() => {
        mega.hidden = false;
        megaToggle.setAttribute('aria-expanded', 'true');
      }, OPEN_DELAY);
    }, { signal });
    megaToggle.addEventListener('click', () => {
      const opening = mega.hidden;
      closeItems();
      mega.hidden = !opening;
      megaToggle.setAttribute('aria-expanded', opening ? 'true' : 'false');
    }, { signal });

    items.forEach(item => {
      const button = item.querySelector('[data-net-nav-button]');
      const dropdown = item.querySelector('[data-net-nav-dropdown]');
      item.addEventListener('pointerenter', () => openItem(item), { signal });
      button?.addEventListener('click', () => {
        if (!dropdown) return;
        if (dropdown.hidden) openItem(item);
        else { dropdown.hidden = true; button.setAttribute('aria-expanded','false'); }
      }, { signal });
      dropdown?.addEventListener('pointerenter', clearTimers, { signal });
      dropdown?.addEventListener('pointerleave', scheduleClose, { signal });
    });

    nav.addEventListener('pointerleave', scheduleClose, { signal });
    nav.addEventListener('pointerenter', clearTimers, { signal });
    mega.addEventListener('pointerenter', clearTimers, { signal });
    mega.addEventListener('pointerleave', scheduleClose, { signal });

    document.addEventListener('pointerdown', e => {
      if (!header.querySelector('.net-ref-navigation-wrap')?.contains(e.target)) {
        hideMega();
        closeItems();
      }
    }, { signal });
    document.addEventListener('keydown', e => {
      if (e.key === 'Escape') {
        hideMega();
        closeItems();
        megaToggle.focus?.();
      }
    }, { signal });
    window.addEventListener('resize', schedulePosition, { passive: true, signal });
    document.addEventListener('scroll', schedulePosition, { passive: true, capture: true, signal });
    document.addEventListener('shopify:section:unload', event => {
      if (!event.target.contains(header)) return;
      controller.abort();
      delete nav.dataset.netMenuInit;
      clearTimers();
      if (positionFrame !== null) cancelAnimationFrame(positionFrame);
      positionFrame = null;
    }, { signal });
  }

  function boot(scope = document) { scope.querySelectorAll?.(ROOT).forEach(initMenu); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => boot());
  else boot();
  document.addEventListener('shopify:section:load', e => boot(e.target));
})();
